import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockCustom extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children, customBlocks) {
        var _a, _b, _c, _d, _e, _f;
        super(model, children);
        this.key = model.customBlockKey;
        // Attach custom block
        this.block = null;
        for (const customBlock of customBlocks) {
            if (customBlock.key === model.customBlockKey) {
                this.block = customBlock;
            }
        }
        // If there is no block attached, it means the block was removed - ignore the payload resolution
        if (!this.block) {
            this.properties = {};
            return;
        }
        // With proper custom block found, add default values for properties first
        const properties = {};
        for (const property of this.block.properties) {
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            properties[property.key] = property.default;
        }
        // Add overrides
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        for (const property of model.customBlockProperties) {
            // TODO:fix-sdk-eslint
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            properties[property.key] = property.value;
            // Deprecated. Old image asset type for backward compatibility
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (((_a = property.value) === null || _a === void 0 ? void 0 : _a.asset) || ((_b = property.value) === null || _b === void 0 ? void 0 : _b.asset) === null) {
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                property.value.assetId = (_d = (_c = property.value.asset) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null;
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                property.value.assetUrl = (_f = (_e = property.value.asset) === null || _e === void 0 ? void 0 : _e.url) !== null && _f !== void 0 ? _f : null;
            }
        }
        this.properties = properties;
    }
}
